import { Injectable } from '@angular/core';
import { MatterRequisitionPrecedent } from '@models/requisitions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './matter-requisitions.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterRequisitionsDispatch {
	@Dispatch()
	Create = (document: MatterRequisitionPrecedent): actions.Create =>
		new actions.Create(document);

	@Dispatch()
	Update = (
		requisitionId: string,
		matterRequisition: Partial<MatterRequisitionPrecedent>,
	): actions.Update => new actions.Update({ requisitionId, matterRequisition });

	/**
	 *   Used to completely replace the requisition with the new data, otherwise fields will persist into a new requisition
	 * 	@description Fields are specific to a requisition, if an update to a new requisition occurs where the fields are not the same,
	 * 	the old fields will persist into the new requisition, this action is used to completely replace the requisition with the new fields.
	 * 	@param requisitionId string
	 * 	@param matterRequisition MatterRequisitionPrecedent
	 * 	@returns actions.UpdateSet
	 */
	@Dispatch()
	Set = (
		requisitionId: string,
		matterRequisition: MatterRequisitionPrecedent,
	): actions.UpdateSet =>
		new actions.UpdateSet({ requisitionId, matterRequisition });

	@Dispatch()
	Remove = (requisitionId: string): actions.Remove =>
		new actions.Remove(requisitionId);
}
